import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'jquery'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { getConfigDetails } from '../../services/config'
// import { Circles } from 'react-loader-spinner'

const ApplePayHL = (props) => {
    const {
        faciltyData,
        getValues,
        setIsSubmittingForm,
        onSubmit,
        applePaySessionRef
    } = props
    const [applePayBtm, setApplePayBtm] = useState(false)
    

    // const navigate = useNavigate()

    useEffect(() => {
        if (window?.ApplePaySession) {
            if(window?.ApplePaySession.canMakePayments()) {
                setApplePayBtm(true)
            }
        }
    }, [])

    const initializeApplePay = () => {
        // Check if the user's browser supports Apple Pay
        if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
            const paymentRequest = {
                countryCode: 'US',
                currencyCode: 'USD',
                supportedNetworks: ['visa', 'masterCard', 'amex'],
                merchantCapabilities: ['supports3DS'],
                total: { label: 'Your Store', amount: Number(faciltyData?.payable_amount)?.toFixed(2) }
            }

            const session = new window.ApplePaySession(3, paymentRequest)
            applePaySessionRef.current = session
            // Validate merchant with your backend PHP script
            session.onvalidatemerchant = (event) => {
                // console.log(event)
                // console.log(event.validationURL, 'event.validationURL')
                // var payload = {'merchantIdentifier':'777704037403','displayName':'Parkengage','initiative':'web','initiativeContext':'https://staging-transient.parkengage.com', 'validationURL': event.validationURL}
                // var payload = {'merchantIdentifier':'merchant.com.ApplePayHLWebSampleFinal','displayName':'Parkengage','initiative':'web','initiativeContext':'https://staging-transient.parkengage.com', 'validationURL': event.validationURL}
            
                // var data = new FormData()
                // data.append( 'json', JSON.stringify( payload ) )
                fetch(`${getConfigDetails().baseURL}apple-pay-session`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    //   body: JSON.stringify({ validationURL: event.validationURL })
                    body: JSON.stringify({ 'merchantIdentifier': faciltyData?.facility?.facility_payment_details?.heartland_applepay_identifier,
                        'displayName': faciltyData?.facility?.facility_payment_details?.heartland_merchant_name,
                        'initiative': 'web',
                        'initiativeContext': window.location.hostname,
                        'validationURL': event.validationURL,
                        'facility_id': faciltyData?.facility?.id
                    })
                    // body: data
                })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        console.error('Merchant validation failed', data.error)
                    } else {
                        const validMerchantData = JSON.parse(data?.data ? data?.data : '{}')
                        // console.log(data, validMerchantData, 'data successfull')
                        session.completeMerchantValidation(validMerchantData)
                    }
                })
                .catch((error) => {
                    session.abort()
                    console.error('Validation error:', error)
                })
            }

            // Handle payment authorization
            session.onpaymentauthorized = (event) => {
                setIsSubmittingForm(true)
                const paymentToken = event?.payment?.token
                const formData = getValues()
                const payload = {
                    ...formData,
                    walletPay: JSON.stringify(paymentToken?.paymentData),
                    amount: Number(faciltyData?.payable_amount)?.toFixed(2),
                    invoice_number: '1234',
                    paymentMethod: 'APL'
                }
                onSubmit(payload)
            }

            // Begin the session
            session.begin()
        } else {
            console.log('Apple Pay is not supported on this device.')
        }
    }


    return (
            <div className='px-4 payButton'>
                { applePayBtm ? <button className="apple-pay-button" id="apple-pay-button" onClick={initializeApplePay}>&nbsp;</button> : '' }
            </div>
    )
}

ApplePayHL.propTypes = {
    faciltyData: PropTypes.object, 
    getValues: PropTypes.func, 
    dispatch: PropTypes.func,
    setIsSubmittingForm: PropTypes.func,
    setIsConfimationModalOpen: PropTypes.func,
    setIsRateMisMatch: PropTypes.func,
    setMismatchRateError: PropTypes.func,
    setIsTokenApiStart: PropTypes.func,
    notify: PropTypes.func,
    onSubmit: PropTypes.func,
    seletedRateBand: PropTypes.string,
    totalHoursLength: PropTypes.string,
    events: PropTypes.array,
    selectedEv: PropTypes.string,
    qrcodeId: PropTypes.string,
    partner: PropTypes.string,
    isDisplayRateBand: PropTypes.bool,
    loginData: PropTypes.object,
    applePaySessionRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
}
 
ApplePayHL.defaulProps = {
    faciltyData: EMPTY_OBJECT,
    getValues: noop, 
    dispatch: noop,
    setIsSubmittingForm: noop,
    setIsConfimationModalOpen: noop,
    setIsRateMisMatch: noop,
    setMismatchRateError: noop,
    setIsTokenApiStart: noop,
    notify: noop,
    onSubmit: noop,
    seletedRateBand: '',
    totalHoursLength: '',
    events: EMPTY_ARRAY,
    selectedEv: '',
    qrcodeId: '',
    partner: '',
    isDisplayRateBand: false,
    loginData: EMPTY_OBJECT,
    applePaySessionRef: null
}


export default ApplePayHL
